<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6.6 3.2 8.2 6 6.9 7.6c.7 1.7 2 3 3.7 3.7L12.2 10l2.8 1.6-.5 2.4c-.2.7-.9 1.2-1.6 1.1C8 14.5 4.7 11.2 4 6.3c-.1-.7.4-1.4 1.1-1.6z"/></svg>
</template>
